import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function NewProjectDialog({ open, onClose, onCreated }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
      setDescription("");
      setTags("");
    }
  }, [open]);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error("Project name is required");
      return;
    }
    setBusy(true);
    try {
      const created = await api.createProject({
        name: name.trim(),
        description: description.trim(),
        tags: tags.split(",").map((t) => t.trim()).filter(Boolean),
      });
      onCreated(created);
    } catch {
      toast.error("Could not create project");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-[#000000]/80 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="new-project-overlay"
    >
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        className="bg-[#050805] border border-[#2D7544] w-full max-w-lg shadow-[6px_6px_0px_#00FF41]"
        data-testid="new-project-dialog"
      >
        <div className="flex items-center justify-between border-b border-[#2D7544] px-5 py-3">
          <div className="dv-overline">New Project</div>
          <button type="button" onClick={onClose} className="p-1 hover:bg-[#0D1F12]" data-testid="close-dialog">
            <X size={16} />
          </button>
        </div>
        <div className="p-5 flex flex-col gap-4">
          <label className="flex flex-col gap-1.5">
            <span className="dv-overline">Name</span>
            <input
              data-testid="project-name-input"
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="dv-input"
              placeholder="Q3 Migration Plan"
            />
          </label>
          <label className="flex flex-col gap-1.5">
            <span className="dv-overline">Description</span>
            <textarea
              data-testid="project-description-input"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="dv-input min-h-[72px] resize-none"
              placeholder="What is this project about?"
            />
          </label>
          <label className="flex flex-col gap-1.5">
            <span className="dv-overline">Tags (comma separated)</span>
            <input
              data-testid="project-tags-input"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              className="dv-input"
              placeholder="research, backend, q3"
            />
          </label>
        </div>
        <div className="border-t border-[#2D7544] px-5 py-3 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="dv-btn-secondary" data-testid="cancel-create">
            Cancel
          </button>
          <button disabled={busy} type="submit" className="dv-btn-primary" data-testid="submit-create">
            {busy ? "Creating…" : "Create"}
          </button>
        </div>
      </form>
    </div>
  );
}
